<script lang="ts">
  import { useFeatureToggle } from "services/configCatService";
  import Productions from "./Productions.svelte";
  import { recentFolders } from "state/page";

  const persistedRecentFolders = localStorage.getItem("recentFolders");

  if (persistedRecentFolders) {
    $recentFolders = JSON.parse(persistedRecentFolders);
  }
</script>

{#await useFeatureToggle("showFolders") then featureEnabled}
  {#if featureEnabled}
    <div class="folders">
      <Productions />
    </div>
  {/if}
{/await}

<style>
  .folders {
    display: flex;
    flex-direction: column;
    gap: var(--org-small);
    margin-top: 3rem;
  }
</style>
